import type { CostState } from "../api/types";

type Kolor = "default" | "info" | "success" | "warning" | "error";

export const STAN_KOSZTU: Record<CostState, { label: string; color: Kolor }> = {
  awaiting_match: { label: "Czeka na dopasowanie", color: "info" },
  verified_local: { label: "Zweryfikowany lokalnie", color: "info" },
  matched: { label: "Dopasowany", color: "info" },
  unmatched: { label: "Niedopasowany", color: "warning" },
  described_draft: { label: "Opisany wstępnie", color: "warning" },
  described_full: { label: "Opisany kompletnie", color: "success" },
  accepted: { label: "Zaakceptowany", color: "success" },
  handed_over: { label: "Przekazany", color: "default" },
  multi_project: { label: "Kilka produkcji", color: "error" },
  rejected: { label: "Odrzucony", color: "error" },
};

/** Stany, w których koszt nie jest jeszcze policzony w kolumnie „rzeczywiste". */
export const NIEPRZYPISANE: CostState[] = [
  "awaiting_match", "verified_local", "matched", "unmatched",
  "described_draft", "multi_project",
];
